<template>
	<v-container fluid>
		<div v-if="!loading">
			<div id="print-pdf">
				<!--table-->
				<v-row class="total secondary--text mb-4">Design preferences</v-row>
				<!--table head-->
				<v-row class="total mt-4" no-gutters>
					<v-col cols="2" class="tabCell text-left">Segment</v-col>
					<v-col cols="10" class="tabCell">
						<v-row no-gutters>
							<v-col class="tabCell text-center">Design type</v-col>
							<v-divider vertical class="mx-1"></v-divider>
							<v-col class="tabCell text-center">Design level</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col v-for="_type in designTypes" 
							:key="_type">
								{{_type}}
							</v-col>
							<v-divider vertical class="mx-1"></v-divider>
							<v-col v-for="i in 5" :key="i">{{'level ' + i}}</v-col>
						</v-row>
					</v-col>
				</v-row>
				<!--table content-->
				<v-row v-for="segment in transparentSegments" :key="segment.id" no-gutters>
					<v-col cols="2" class="tabCell text-left">{{segment.name}}</v-col>
					<v-col v-for="_type in designTypes" 
						:key="_type" class="tabCell">
						{{format(segment['design'+ _type])}}
					</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell" v-for="i in 5" :key="i">
						{{format(segment['designLevel'+ i])}}
					</v-col>
				</v-row>
				<div v-if="marketConsultancy">
					<v-row 
						v-for="segment in hiddenSegments"
						:key="segment.id" 
						class="secondary--text"
						no-gutters>
						<v-col cols="2" class="tabCell text-left">{{segment.name}}</v-col>
						<v-col v-for="_type in designTypes" :key="_type" class="tabCell">
							{{format(segment['design'+ _type])}}
						</v-col>
						<v-divider vertical class="mx-1"></v-divider>
						<v-col class="tabCell" v-for="i in 5" :key="i">
							{{format(segment['designLevel'+ i])}}
						</v-col>
					</v-row>
				</div>
			</div>
			<v-row class="ma-4" justify="end">
				<v-btn
					color="#1A237E" small dark
					class="text-lowercase"
					@click="generateReport"
					>save in PDF
				</v-btn>
			</v-row>	
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import numeral from 'numeral'
	import html2pdf from 'html2pdf.js'
	import Loader from '../../../layouts/Loader.vue'

	export default {
		props: ['company', 'gameId', 'round'],
		data (){
			return {
				designTypes: ['Classic', 'Business', 'Casual', 'Innovative', 'Art'],
				
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			segments () {
				return this.$store.getters.segments
			},
			transparentSegments () {
				return this.segments.filter(seg => seg.type == 'transparent')
			},
			hiddenSegments () {
				return this.segments.filter(seg => seg.type == 'hidden')
			},
			projects () {
				return this.$store.getters.projects
			},
			marketConsultancy () {
				return Boolean(this.projects.find(project => project.name == 'Marketing & Retail'))
			}
		},
		methods: {
			//format in numeral
			format (param) {
				return numeral(param).format('% 0[.]0')
			},
			total (param) {
				const transparent = this.transparentSegments.reduce((sum, seg) => {
					return sum+= seg[param]
				}, 0)
				let hidden = 0
				if (this.marketConsultancy) {
						hidden = this.hiddenSegments.reduce((sum, seg) => {
						return sum+= seg[param]
					}, 0)
				}
				return transparent + hidden
			},
			generateReport () {
				let element = document.getElementById('print-pdf');
				var opt = {
					margin: 1,
					filename: 'DesignReport.pdf',
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas:  { scale: 2 },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
					pagebreak: { mode: 'avoid-all', before: '.nextPage' }
				};
				// New Promise-based usage:
				html2pdf().set(opt).from(element).save();
			}
		},
		components: {Loader}
	}	
</script>